import { createFileRoute } from "@tanstack/react-router";

import { NadzorenOdborPage } from "../about_.nadzoren-odbor";

export const Route = createFileRoute("/en/about_/nadzoren-odbor")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Supervisory Board | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Members of the Supervisory Board of Makedonijaturist AD. Supervision of operations and strategic growth directions.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about/nadzoren-odbor",
			},
		],
	}),
	component: NadzorenOdborPage,
});
